/**
 * Official App Store + Google Play badges for marketing CTAs.
 * Quiet secondary install path — never replaces the primary web signup CTA.
 */

/** Core iOS listing (bundle com.golfauth.app). Country-neutral —
 *  Apple routes the visitor to their local storefront for this app id. */
export const APP_STORE_URL =
  'https://apps.apple.com/app/golfauth/id6776860007';

/** Core Android listing (applicationId com.golfauth.core). */
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.golfauth.core';

type StoreBadgesProps = {
  /** Hero = left-aligned; closing CTA = centered. */
  align?: 'start' | 'center';
  className?: string;
};

export default function StoreBadges({
  align = 'start',
  className = '',
}: StoreBadgesProps) {
  const classes = [
    'store-badges',
    align === 'center' ? 'centered' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes} aria-label="Download GolfAuth">
      <a
        href={APP_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-badge"
      >
        <img
          src="/marketing/store/app-store-badge.svg"
          alt="Download on the App Store"
          width={120}
          height={40}
          loading="lazy"
          decoding="async"
        />
      </a>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="store-badge"
      >
        <img
          className="play"
          src="/marketing/store/google-play-badge.png"
          alt="Get it on Google Play"
          width={135}
          height={40}
          loading="lazy"
          decoding="async"
        />
      </a>
    </div>
  );
}
